import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTopButton from '@/components/base/ScrollToTopButton';
import SEOSchema from '@/components/base/SEOSchema';
import HeroSection from './components/HeroSection';
import FeaturedWorks from './components/FeaturedWorks';
import CategoryNav from './components/CategoryNav';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';
import { faqs } from '@/mocks/articles';

export default function Home() {
  return (
    <>
      <SEOSchema type="Organization" />
      <SEOSchema type="WebSite" />
      <SEOSchema
        type="WebPage"
        data={{
          name: '纲手本子·高质量同人创作合集 - 首页',
          description: '纲手本子是火影忍者同人创作中最受欢迎的主题之一，汇聚高质量纲手本子插画、漫画与同人故事，收录多风格纲手本子内容，定期更新。',
          url: 'https://tsunade-doujin.readdy.ai/',
        }}
      />
      <SEOSchema type="FAQPage" data={{ questions: faqs }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <article>
            <HeroSection />
            <FeaturedWorks />
            <CategoryNav />
            <LatestUpdates />
            <FAQSection />
          </article>
        </main>

        <Footer />
        <ScrollToTopButton />
      </div>
    </>
  );
}